<mat-form-field class="sg-input-form-field" appearance="outline" *ngIf="withIcon">
  <ptl-icon matPrefix [icon]="icon" size="s"></ptl-icon>
  <input
    #inputElement
    matInput
    [type]="type"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [value]="value"
    [matAutocomplete]="matAutocomplete"
    (input)="onInputChange($event)"
    (blur)="onBlur()"
    (focus)="onFocus()"
  />
</mat-form-field>

<div class="sg-input-container" *ngIf="!withIcon">
  <h2 class="sg-input-title small bold" *ngIf="label">{{ label }}</h2>
  <p class="sg-input-description extra-small" *ngIf="description">{{ description }}</p>
  <input
    #inputElement
    matInput
    class="sg-input-field"
    [attr.aria-label]="label"
    [type]="type"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [value]="value"
    [matAutocomplete]="matAutocomplete"
    (input)="onInputChange($event)"
    (blur)="onBlur()"
    (focus)="onFocus()"
  />
</div>
